import React from 'react';
import Link from 'gatsby-link';
import { Grid, Button } from '@material-ui/core';
import logoImage from '../../images/logo.png';
import styled from '../../utils/styled';

const HeaderWrapper = styled(Grid, {
  component: 'header',
  container: true,
  spacing: 16,
})(theme => ({
  background: theme.palette.background.default,
}));

const HeaderContent = styled(Grid)(theme => ({
  textAlign: 'center',
}));

const Navigation = styled('nav')(theme => ({
  padding: `${theme.spacing.unit * 1}px 0`,
}));

const Title = styled('h1')(theme => ({
  margin: 0,
}));

const Logo = styled('img')(theme => ({
  marginTop: theme.spacing.unit * 1,
  height: 166,
}));

const NavLink = styled(Button, { component: Link })(theme => ({
  color: 'gray',
  fontSize: 14,
}));

const Header = ({ data: { site } }) => (
  <HeaderWrapper>
    <HeaderContent item xs={12}>
      <Link to="/">
        <Logo src={logoImage} alt={site.siteMetadata.title} />
      </Link>
      <Navigation>
        <NavLink to="/">Algus</NavLink>
        <NavLink to="/events">Sündmused</NavLink>
        <NavLink to="/services">Teenused</NavLink>
        <NavLink to="/contact">Kontakt</NavLink>
      </Navigation>
    </HeaderContent>
  </HeaderWrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js